module.exports = __webpack_public_path__ + "img/GB.c4cd6642.svg";